import { render, staticRenderFns } from "./SystemErrorPage.vue?vue&type=template&id=987debf4&"
import script from "./SystemErrorPage.vue?vue&type=script&lang=js&"
export * from "./SystemErrorPage.vue?vue&type=script&lang=js&"
import style0 from "./SystemErrorPage.vue?vue&type=style&index=0&id=987debf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports